import { RequireKey } from "@material-dev/insights-portal-ui-components/lib/types";

import { OriginProjectDto } from "app/ApiClient";
import { BaseState } from "..";

export type NormalizedOriginProject = RequireKey<OriginProjectDto, "name">;
export default interface OriginProjectState extends BaseState {
  originProjects: NormalizedOriginProject[];
  isFetching?: boolean;
}

export const defaultOriginProjectsState: OriginProjectState = {
  processing: false,
  finished: false,
  failed: false,
  succeed: false,
  error: "",
  originProjects: [],
  isFetching: false,
};
